import {CognitoUserSession} from 'amazon-cognito-identity-js'
import {Auth} from 'aws-amplify'

export function checkCurrentUser(): Promise<CognitoUserSession> {
    return Auth.currentSession()
}
